module.exports = __webpack_public_path__ + "static/img/s2.6ee5122.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/s2.png
// module id = 7OQ0
// module chunks = 0